import { PlaceholderTextFormat } from "canvas/widgets/interfaces/model/enumerations/PlaceholderTextFormat";
import { DEFAULT_CANVAS_MODE } from "../../Constants";
import { ICanvasEditor } from "../../widgets/interfaces/model/index";
import { createReducers } from "../util";
import {
	setCanvasContainer,
	setCanvasDimension,
	setCanvasMode,
	setCanvasZoom,
	setEditable,
	setFormatPainter,
	setFroalaLicense,
	setIsCanvasTemplate,
	setPanningMode,
	setSelectedCurvePoint,
	setSnapToGrid,
	setSnapToGuide,
	setPlaceholderTextFormat,
} from "./CanvasEditorOperations";

/**
 * Default state for canvas editor
 */
const initialState: ICanvasEditor  = {
	canvasContainerEl: undefined,
	editorHeight: 720,
	editorWidth: 665,
	/**
     * Froala license is suppose to be constant. However, it is being passed by host application hence
     * maintaining in redux state.
     * This will be accessible via stateAwareConstants module
     */
	froalaLicense: undefined,
	gridInc: 10,
	isEditEnabled: false,
	isFormatPainterActive: false,
	isPanning: false,
	/**
     * Snap to grid flag.
     * Set by user.
     * Accessible via stateAwareConstant module
     */
	isSnapToGrid: false,
	isSnapToGuide: true,
	mode: DEFAULT_CANVAS_MODE,
	pasteObjectOffset: 20,
	placeholderTextFormat: PlaceholderTextFormat.ALL,
	zoomFactor: 1,
} ;

/**
 * Action constants for canvas editor operations
 */

export enum CanvasEditorConstants {
    DUMMY_ACTION = "DUMMY_ACTION",
    SET_AUTOSIZE = "SET_AUTOSIZE",
    SET_CANVAS_CONTAINER = "SET_CANVAS_CONTAINER",
    SET_CANVAS_DIMENSION = "SET_CANVAS_DIMENSION",
    SET_CANVAS_MODE = "SET_CANVAS_MODE",
    SET_CANVAS_PAN = "SET_CANVAS_PAN",
    SET_FORMAT_PAINTER = "SET_FORMAT_PAINTER",
    SET_SNAP_TO_GRID = "SET_SNAP_TO_GRID",
    SET_SNAP_TO_GUIDE = "SET_SNAP_TO_GUIDE",
    ENABLE_EDITING= "ENABLE_EDITING",
    SET_FROALA_LICENSE = "SET_FROALA_LICENSE",
    SET_CANVAS_ZOOM = "SET_CANVAS_ZOOM",
    SET_CURVE_POINT_INDEX = "SET_CURVE_POINT_INDEX",
    SET_IS_CANVAS_TEMPLATE = "SET_IS_CANVAS_TEMPLATE",
    SET_PLACEHOLDER_LABEL_VALUE = "SET_PLACEHOLDER_LABEL_VALUE",
}

/**
 * Canvas editor reducers
 */
export const canvasEditor = createReducers(initialState, {
	[CanvasEditorConstants.SET_CANVAS_CONTAINER]: setCanvasContainer,
	[CanvasEditorConstants.SET_CANVAS_DIMENSION]: setCanvasDimension,
	[CanvasEditorConstants.SET_CANVAS_MODE]: setCanvasMode,
	[CanvasEditorConstants.SET_CANVAS_PAN]: setPanningMode,
	[CanvasEditorConstants.SET_FORMAT_PAINTER]: setFormatPainter,
	[CanvasEditorConstants.SET_SNAP_TO_GRID]: setSnapToGrid,
	[CanvasEditorConstants.SET_SNAP_TO_GUIDE]: setSnapToGuide,
	[CanvasEditorConstants.ENABLE_EDITING]: setEditable,
	[CanvasEditorConstants.SET_FROALA_LICENSE]: setFroalaLicense,
	[CanvasEditorConstants.SET_CANVAS_ZOOM]: setCanvasZoom,
	[CanvasEditorConstants.SET_IS_CANVAS_TEMPLATE]: setIsCanvasTemplate,
	[CanvasEditorConstants.SET_CURVE_POINT_INDEX]: setSelectedCurvePoint,
	[CanvasEditorConstants.SET_PLACEHOLDER_LABEL_VALUE]: setPlaceholderTextFormat,
});
